import axios from '../axios';

export default {
  getManagementsGroups (options) {
    const params = {};

    if (options.pagination) {
      params.pagination = 1;
    }

    if (options.page) {
      params.page = options.page;
    }

    if (options.limit) {
      params.limit = options.limit;
    }

    if (options.filters && Object.keys(options.filters).length) {
      for (const filterName in options.filters) {
        params[`filter[${filterName}]`] = options.filters[filterName];
      }
    }

    if (options.sort) {
      params.sort = options.sort;
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }

    return new Promise((resolve, reject) => {
      axios.get('/management-group?' + query.join('&'))
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getManagementGroup (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/management-group/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  createManagementGroup (params) {
    return new Promise((resolve, reject) => {
      axios.post('/management-group', params)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  updateManagementGroup (id, data) {
    return new Promise((resolve, reject) => {
      axios.put(`/management-group/${id}`, data)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  deleteManagementGroup (id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/management-group/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
};
